import React from 'react';
import { Calendar } from 'lucide-react';
export function LiveQA() {
  return <section className="w-full bg-orla-bone py-32 md:py-[128px] px-6" data-id="element-225">
      <div className="max-w-[1240px] mx-auto" data-id="element-226">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-227">
          {/* Left Column - Content */}
          <div className="flex flex-col justify-center" data-id="element-228">
            {/* Eyebrow */}
            <p className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em] mb-4" data-id="element-229">
              ASK THE EXPERTS
            </p>

            {/* Heading */}
            <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-[-0.02em] leading-[1.1] mb-6" data-id="element-230">
              Ask an Orla physician. Live.
            </h2>

            {/* Body Text */}
            <p className="font-body text-[17px] text-orla-muted leading-[1.6] max-w-[480px] mb-8" data-id="element-231">
              Every month, our physicians host a live Q&A. Bring your questions
              about perimenopause, HRT, symptoms, or anything in between. No
              scripts, no dodging, no sales pitch — just answers.
            </p>

            {/* Info Row */}
            <div className="flex items-center gap-3 mb-10" data-id="element-232">
              <Calendar className="w-5 h-5 text-orla-saffron" data-id="element-233" />
              <p className="font-body font-medium text-[14px] text-orla-ink" data-id="element-234">
                Next session:{' '}
                <span className="italic text-orla-muted" data-id="element-235">
                  Tuesday, May 5 · 6pm ET
                </span>
              </p>
            </div>

            {/* CTAs */}
            <div className="flex flex-row flex-wrap gap-4" data-id="element-236">
              <button className="bg-orla-sienna text-orla-bone font-body font-semibold text-[15px] px-7 py-[14px] rounded-full hover:opacity-90 transition-opacity duration-200" data-id="element-237">
                Register Now
              </button>
              <a href="#" className="font-body font-semibold text-[15px] text-orla-saffron hover:underline transition-all duration-200 flex items-center" data-id="element-238">
                Watch a recorded Q&A →
              </a>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="order-first md:order-last" data-id="element-239">
            <div className="aspect-[4/5] rounded-2xl shadow-md overflow-hidden" data-id="element-240">
              <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80" alt="Two physicians in conversation" className="w-full h-full object-cover" data-id="element-241" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}